import { ROLES, RoleType } from "utils/constants"

export function isValidRole(role: string | undefined): role is RoleType {
    return role === ROLES.PSY || role === ROLES.CLIENT
}
